/* global BUILD_VERSION */
import Rollbar from 'rollbar';

import { getEnvConstants } from 'helpers/envConstants';

const allowedHosts = ['localhost', 'relishedfoods', 'homechef.com', 'webpack'];
const isAllowedHost = testString => allowedHosts.some(hostName => testString.includes(hostName));
const ignoredMessages = [
  // Ignoring a bunch of errors which...we honestly don't know where they come from. Extensions, tracking scripts, and ad blockers.
  'UET is not defined',
  'find variable: UET',
  'find variable: _taq',
  'us-central1-adaptive-growth.cloudfunctions.net',
  'EBTMobile.elementInteractionManager.loadJQueryIfNeeded',
  /redefine non-configurable property.*userAgent*/,
  'No identifiers allowed directly after numeric literal',

  // Ignoring an IE-specific error for the 'google-maps-react' library
  /loaderCB\d+ is not a function/,
];

const isFromWebpackBuild = payload => {
  const {
    body: {
      trace: { frames },
    },
  } = payload;
  return frames.some(frame => frame.filename.includes('packs/js'));
};

const ignoreRemoteUncaught = payload => {
  try {
    return payload.body.trace.frames.some(frame => !isAllowedHost(frame.filename));
  } catch (e) {
    return true;
  }
};

function initialize() {
  const { RUNTIME_ENV, ROLLBAR_TOKEN } = getEnvConstants();

  if (!ROLLBAR_TOKEN) return null;
  try {
    return new Rollbar({
      accessToken: ROLLBAR_TOKEN,
      captureUncaught: true,
      captureUnhandledRejections: true,
      hostBlackList: ['-extension'],
      hostWhiteList: allowedHosts,
      onSendCallback: (isUncaught, _, payload) => {
        if (isUncaught && !isFromWebpackBuild(payload)) {
          payload.server.root = window.location.origin;
        }
      },
      checkIgnore: (isUncaught, _args, payload) => {
        if (isUncaught) return ignoreRemoteUncaught(payload);
        return false;
      },
      ignoredMessages,
      payload: {
        environment: RUNTIME_ENV,
        client: {
          javascript: {
            code_version: BUILD_VERSION,
            source_map_enabled: true,
            populate_empty_backtraces: true,
          },
        },
        server: {
          root: 'webpack:///./',
        },
      },
    });
  } catch (e) {
    console.warn(`WARNING: Rollbar initialization failed: ${e}`); // eslint-disable-line no-console
    return null;
  }
}

const rollbar = initialize();

export function setUser({ id, email, name }) {
  if (!rollbar) return;
  rollbar.configure({
    payload: {
      person: {
        id,
        email,
        username: name,
      },
    },
  });
}

export function captureException(error, context = {}) {
  if (!rollbar) return;
  return rollbar.error(error, { log_extra: context });
}
